import { useCallback, useMemo } from 'react';

import { useLazyQuoteApi } from 'Shared/services/Api';
import { useAppContext } from 'QuoteApp/services/providers/AppProvider';
import {
  GetDetailsResponseType,
  transformAppDetails,
} from 'QuoteApp/services/endpoints/GetDetails';
import { env } from 'Shared/constants/env';

export const useInitializeCoveragesCommand = (
  details: GetDetailsResponseType | null,
  setDetails: (details: GetDetailsResponseType) => void
) => {
  const initializeCoveragesCommand = useMemo(() => {
    return details?.commands?.insuranceProduct?.find(
      c => c.name === 'initialize_coverages'
    );
  }, [details]);

  const [{ loading: pending }, initializeCoveragesRequest] = useLazyQuoteApi<
    GetDetailsResponseType
  >({
    url: initializeCoveragesCommand?.uri,
    baseURL: env.reznorHostname, // command uri already starts with '/api/v3'
    method: 'POST',
    transformResponse: transformAppDetails,
  });

  const runnable = !!initializeCoveragesCommand?.runnable;

  const initializeCoverages = useCallback(() => {
    return initializeCoveragesRequest().then(response => {
      setDetails(response.data);
      return response.data;
    });
  }, [initializeCoveragesRequest, setDetails]);

  return useMemo(() => {
    return {
      perform: initializeCoverages,
      pending,
      runnable,
    };
  }, [initializeCoverages, pending, runnable]);
};

const blankCommand = {
  runnable: false,
  perform: async () => null,
  pending: false,
};

export const useInitializeCoverages = () => {
  const { initializeCoverages } = useAppContext();

  return initializeCoverages || blankCommand;
};
